import { parsePhoneNumber, ParseError } from 'libphonenumber-js/max';
import countryCodes from '../../lib/utils/country-codes';
import { VALID, INVALID } from './shared-constants';
export var PHONE_TYPES = {
  MOBILE: 'MOBILE',
  FIXED_LINE: 'FIXED_LINE',
  FIXED_LINE_OR_MOBILE: 'FIXED_LINE_OR_MOBILE',
  OTHER: 'OTHER'
};
export var PARSE_ERROR_TYPE = {
  INVALID_COUNTRY: 'Invalid Country',
  NOT_A_NUMBER: 'Not a valid phone number',
  TOO_LONG: 'Phone number is too long',
  TOO_SHORT: 'Phone number is too short'
};
export var parse = function parse(phoneNumber, defaultCountryCode) {
  var parseFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'E.164';
  var result = {
    valid: INVALID,
    phone: null,
    countryCode: null,
    phoneType: null,
    error: {
      type: 'genericError',
      message: "Invalid phone number: ".concat(phoneNumber)
    }
  };
  if (!phoneNumber || !String(phoneNumber || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid phoneNumber';
    return result;
  }
  try {
    result.countryCode = countryCodes.getCountryCode(phoneNumber) || defaultCountryCode;
    var phone = parsePhoneNumber(phoneNumber, result.countryCode.toUpperCase());
    if (!phone.isPossible()) {
      result.error = {
        type: 'impossibleNumber',
        message: 'Impossible phone number'
      };
      return result;
    }
    if (!phone.isValid()) {
      result.error = {
        type: 'invalidPhoneNumber',
        message: 'Invalid phone number'
      };
      return result;
    }
    return {
      valid: VALID,
      phone: parseFormat === 'NATIONAL_SHORT' ? phone.format('NATIONAL').replace(/[^0-9]/g, '') : phone.format(parseFormat),
      countryCode: result.countryCode,
      phoneType: PHONE_TYPES[phone.getType()] || PHONE_TYPES.OTHER,
      error: {
        type: null,
        message: null
      }
    };
  } catch (err) {
    if (err instanceof ParseError) {
      result.valid = INVALID;
      result.error = {
        type: 'parseError',
        message: PARSE_ERROR_TYPE[err.message]
      };
    } else {
      result.valid = INVALID;
    }
    return result;
  }
};